/**
 * Outline compass / explore icon styled to match Tabler Icons conventions:
 * stroke-based, no fill, strokeWidth=2, rounded joins and caps.
 *
 * Used as the "Hubs" tab icon in the main navigation bar.
 */
export function IconExploreRounded({ size = 24, color = 'currentColor' }: { size?: number; color?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="10" />
      <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" />
    </svg>
  );
}
